var formatter = new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export function perfomUpdate(input, quantity) {
    let id = input.dataset.id;

    cart.getItem(id).then(item => {

        let productObj = {quantity: parseInt(quantity)};

        if (item === null) {
            cart.addItem(id, productObj).then(state => {

            });
        } else {
            cart.updateItem(id, productObj).then(state => {
                document.getElementById('subtotal').innerHTML = formatter.format(state.items_subtotal_price / 100);

                state.items.forEach(item => {
                    document.querySelector('div[data-key="' + item.key + '"] .final-price').innerHTML = format(item.final_line_price);
                })
            }).catch(e => {
                alert(e);
            });
        }
    })
}

export function updateCart(e) {
    let quantity = e.target.value;

    if (quantity < 1){
        e.target.value = 1;
        e.preventDefault();
        return;
    }

    if (quantity > e.target.max){
        e.target.value = e.target.max;
        e.preventDefault();
        return;
    }

    perfomUpdate(e.target, quantity);
}

export function format(amount){
    return formatter.format(amount / 100);
}
